import styled from "styled-components";

export const ContactUsDiv = styled.div`
max-width:100vw;
  /* background:linear-gradient(270deg, #596B80 27.08%, #0C1A2B 112.98%); */
/* background:red; */

`